import { useIsMobile } from '@wellesley/ui'

const PREVIEW_SIZE = 250
const MOBILE_PREVIEW_SIZE = 167

export const getPreviewSize = (isMobile: boolean) =>
  isMobile ? MOBILE_PREVIEW_SIZE : PREVIEW_SIZE

const usePreviewSize = (previewSize?: number) => {
  const isMobile = useIsMobile()
  const defaultPreviewSize = getPreviewSize(isMobile)

  return previewSize || defaultPreviewSize
}

export default usePreviewSize
